'use client';

import React, { useMemo } from 'react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import ScrollToTop from '@/components/scrollToTop';
import Layout from '@/components/layout/Layout';
import App from '@/App';
import { getHistory } from '@/utils/history';
import { usePathname, useSearchParams } from 'next/navigation';

// This catch-all page hands routing control over to the React Router <App />
export default function CatchAllPage() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const history = useMemo(() => {
        if (typeof window !== 'undefined') {
            return getHistory();
        }

        const searchString = searchParams?.toString() ?? '';

        return getHistory({
            pathname: pathname ?? '/',
            search: searchString ? `?${searchString}` : '',
        });
    }, [pathname, searchParams]);

    return (
        <HistoryRouter history={history}>
            <ScrollToTop />
            <Layout>
                <App />
            </Layout>
        </HistoryRouter>
    );
}
